import { ViewButton } from 'components/ActionStyles/ActionStyles'
import AntdAvatar from 'components/Avatar'
import Pagination from 'components/Pagination'
import {
  FlexWrap,
  RowNumberData,
  Wrapper,
} from 'components/TableStyles/TableContentStyles/TableContentStyles'
import { StyledTable } from 'components/TableStyles/TableStyles'
import GreenStarIcon from 'components/icons/GreenStarIcon'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router'
import { roleBasedDegreeListConvertion } from 'utils/roleBasedDegreeListConvertion'
import { RowNumberDriveAlignCenter } from '../../../../../components/TableStyles/TableContentStyles/TableContentStyles'
import {
  getCandidateDetails,
  getEvaluationDetails,
  getPromotion,
  getSingleRoleData,
  getStdRankAlgoData,
} from '../../../actions'
import CandidateViewDrawer from './Partials/CandidateViewDrawer'
import CandidateViewFilter from './Partials/CandidateViewFilter/index'

const ApplicationTable = ({
  applicantCandidateList,
  singleRoleData,
  searchValue,
  setSearchValue,
  viewRoleDetails = false,
  atsBasedCollegeList,
  atsBasedLocationList,
  atsBasedDegreeList,
  setSearchParams,
  currentTab,
  setStatus,
  filterStatus,
  setFilterStatus,
  status,
  selectedRound,
  applicantMetrics,
  handleSort,
  setCandidateFilterData,
  candidateFilterData,
  pageNum,
  pageLimit,
  setCheckedIds,
  checkedIds,
  onPageChange,
  setLoading,
  loading,
}) => {
  const params = useParams()
  const convertedAtsBasedDegreeList = atsBasedDegreeList?.map(item => ({
    degree: item?.currentCourse?.degree,
    degreeId: item?.currentCourse?.degreeId,
    streams: item?.currentCourse?.streams,
  }))

  const dispatch = new useDispatch()
  useEffect(() => {
    if (params?.jobId) {
      dispatch(getSingleRoleData(1, params.jobId))
    }
  }, [params?.jobId])
  const [checkedKeys, setCheckedKeys] = useState([])

  const [candidateRating, setCandidateRating] = useState({
    minValue: 0,
    maxValue: 5,
  })
  const [singleCandidateRating, setSingleCandidateRating] = useState({})
  const [candidateStatus, setCandidateStatus] = useState([])
  const [campusIds, setCampusIds] = useState([])
  const [rolesDegreeList, setRolesDegreeList] = useState([])
  const [candidateDrawer, setCandidateDrawer] = useState(false)
  const [instituteSearch, setInstituteSearch] = useState('')
  const [locationLoading, setLocationLoading] = useState(false)

  const handleCandidate = (studentId, items) => {
    setCandidateDrawer(true)
    setSingleCandidateRating(items)
    dispatch(getPromotion(studentId))
    dispatch(getCandidateDetails({ studentId, roleId: params?.jobId, setLoading }))
    dispatch(getStdRankAlgoData(params?.jobId, studentId))
    dispatch(getEvaluationDetails(params?.jobId, studentId))
  }

  const columns = [
    {
      title: 'candidate Name',
      dataIndex: 'firstName',
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      render: (_, { student }) => (
        <FlexWrap alignCenter gap="8px">
          <AntdAvatar
            src={student?.profileUrl}
            size={25}
            IconName={student?.firstName?.split('')[0]}
          />
          <RowNumberData>
            {student?.firstName + ' ' + student?.lastName}
          </RowNumberData>
        </FlexWrap>
      ),
    },
    singleRoleData?.jobTypeLevels?.[0] !== 'EXPERIENCED'
      ? {
          title: 'College Name',
          dataIndex: 'instituteCampusName',
          sorter: true,
          sortDirections: ['ascend', 'descend'],
          render: (_, { student }) => {
            return (
              <RowNumberData>
                {student?.instituteCampusName ? (
                  student.instituteCampusName
                ) : (
                  <span
                    style={{
                      display: 'inline-block',
                      textAlign: 'center',
                      width: '100%',
                    }}
                  >
                    -
                  </span>
                )}
              </RowNumberData>
            )
          },
        }
      : {},
    {
      title: 'Location',
      dataIndex: 'corrCity',
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      render: (_, { student }) => (
        <RowNumberData>
          {student?.studentPersonalProfile?.corrCity}
        </RowNumberData>
      ),
    },
    {
      title: 'Deg & Department',
      dataIndex: 'degree',
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      width: 200,
      render: (_, { student }) => (
        <RowNumberData>{pastCourseDetails(student)}</RowNumberData>
      ),
    },
    // singleRoleData?.jobTypeLevels?.[0] !== 'EXPERIENCED'
    //   ? {
    //       title: 'Rating',
    //       dataIndex: 'rating',
    //       sorter: true,
    //       sortDirections: ['ascend', 'descend'],
    //       render: rating => (
    //         <FlexWrap gap="5px">
    //           <RowNumberDriveAlignCenter>
    //             {Number(rating)?.toFixed(2)}
    //           </RowNumberDriveAlignCenter>
    //           <AntdAvatar
    //             size={22}
    //             IconName={<GreenStarIcon />}
    //             background="none"
    //           />
    //         </FlexWrap>
    //       ),
    //     }
    //   : {},

    {
      title: 'Action',
      render: (items, { student }) => (
        <ViewButton
          student={student}
          onClick={() => handleCandidate(student?.id, items)}
          height="32px"
          text={'View Details'}
        />
      ),
    },
  ]

  useEffect(() => {
    const updatedData = roleBasedDegreeListConvertion({
      listOfDegree: convertedAtsBasedDegreeList,
      parentNameParam: 'degree',
      parentValueParam: 'degreeId',
      pathName: 'streams',
      childrenValueParam: 'degreeStreamMapId',
    })
    setRolesDegreeList(updatedData)
  }, [atsBasedDegreeList])

  const pastCourseDetails = student => {
    if (student?.isExpCandidate === true) {
      return student?.educationProfile?.map(education => {
        const { educationLevel, degree, department } = education || {}
        if (['phd', 'pg', 'ug'].includes(educationLevel)) {
          return `${degree?.toLowerCase()} - ${department?.toLowerCase()}`
        }
      })
    } else {
      return `${
        student?.currentCourse?.shortForm
          ? student?.currentCourse?.shortForm
          : student?.currentCourse?.degree?.toLowerCase()
      } - ${student?.currentCourse?.department?.toLowerCase()}`
    }
  }

  return (
    <Wrapper>
      <CandidateViewFilter
        status={status}
        setLocationLoading={setLocationLoading}
        locationLoading={locationLoading}
        singleRoleData={singleRoleData}
        setSearchValue={setSearchValue}
        applicantCandidateList={applicantCandidateList}
        candidateFilterData={candidateFilterData}
        setCandidateFilterData={setCandidateFilterData}
        searchValue={searchValue}
        candidateRating={candidateRating}
        setCandidateRating={setCandidateRating}
        candidateStatus={candidateStatus}
        setCandidateStatus={setCandidateStatus}
        instituteSearch={instituteSearch}
        setInstituteSearch={setInstituteSearch}
        degreeListData={rolesDegreeList}
        checkedKeys={checkedKeys}
        setCheckedKeys={setCheckedKeys}
        checkedIds={checkedIds}
        setCheckedIds={setCheckedIds}
        campusIds={campusIds}
        setCampusIds={setCampusIds}
        viewRoleDetails={viewRoleDetails}
        setSearchParams={setSearchParams}
        currentTab={currentTab}
        setStatus={setStatus}
        filterStatus={filterStatus}
        setFilterStatus={setFilterStatus}
        atsBasedCollegeList={atsBasedCollegeList}
        atsBasedLocationList={atsBasedLocationList}
      />
      <StyledTable
        loading={loading}
        columns={columns}
        pagination={false}
        dataSource={applicantCandidateList?.candidateList}
        rowKey={student => student?.student?.id}
        onChange={handleSort}
      />
      {applicantCandidateList?.count > 0 && (
        <Pagination
          onChange={onPageChange}
          totalPages={applicantCandidateList?.totalPage * 10}
          pageSize={pageLimit}
          current={pageNum || pageNum + 1}
        />
      )}
      {candidateDrawer && (
        <CandidateViewDrawer
          candidateDrawer={candidateDrawer}
          setCandidateDrawer={setCandidateDrawer}
          singleRoleData={singleRoleData}
          selectedRound={selectedRound}
          applicantMetrics={applicantMetrics}
          singleCandidateRating={singleCandidateRating}
        />
      )}
    </Wrapper>
  )
}

export default ApplicationTable
